"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstOrUndefined = exports.getFirstOrDefault = exports.isEmptyArray = exports.nonEmptyArr = void 0;
const nonEmptyArr = (x) => Array.isArray(x) && x.length > 0;
exports.nonEmptyArr = nonEmptyArr;
const isEmptyArray = (x) => !Array.isArray(x) || (Array.isArray(x) && x.length === 0);
exports.isEmptyArray = isEmptyArray;
function getFirstOrDefault(arr, default_) {
    return (0, exports.nonEmptyArr)(arr) ? arr[0] : default_;
}
exports.getFirstOrDefault = getFirstOrDefault;
function getFirstOrUndefined(arr) {
    return getFirstOrDefault(arr, undefined);
}
exports.getFirstOrUndefined = getFirstOrUndefined;
